import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { PaymentModule } from '@acepteam/payment';
import { AcepGlobalModule } from '@acepteam/globalspack';
import { MaterialModule } from './shared/material.module';
import { AppRoutingModule } from './app.routing.module';
import { MemberappModule } from './memberapp/memberapp.module';
import { SafePipe } from './core/pipes/safe.pipe';


@NgModule({
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA
	],
	declarations: [
		AppComponent,
		SafePipe
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		MemberappModule,
		CoreModule.forRoot(),
		PaymentModule.forRoot(),
		AcepGlobalModule.forRoot(),
		AppRoutingModule

	],
	providers: [

	],
	bootstrap: [AppComponent]
})
export class AppModule { }
